module.exports = __webpack_public_path__ + "static/8-Commercial-Shop-Front-view-811a1de92d624731d1d9ab97a6e66408.jpeg";